import React, { useState } from "react";

export default function Icons({
    name,
    width,
    height,
    fill,
    hoverColor,
    cardIndex,
    cardName
}) {
    return (
        <>
            { name === "solutionficon1" ? (
        <svg
          width="40"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3661_5067)">
            <path
              d="M25 50C24.1895 49.8928 23.4101 49.6182 22.7114 49.1937C22.0127 48.7692 21.4098 48.2041 20.9412 47.5342C20.4945 46.9751 19.9508 46.5011 19.3359 46.1349C18.5837 46.1289 17.8376 46.2688 17.1387 46.5469C16.414 46.8833 15.6276 47.0663 14.8288 47.0844C14.03 47.1025 13.2362 46.9554 12.4969 46.6522C11.8588 46.1588 11.3297 45.5385 10.9431 44.8305C10.5566 44.1225 10.3208 43.3421 10.2508 42.5384C10.1437 41.8089 9.89932 41.1064 9.53062 40.4678C8.89251 40.1001 8.1904 39.8567 7.46156 39.7507C6.65801 39.6803 5.8777 39.4445 5.16972 39.0579C4.46175 38.6714 3.84142 38.1425 3.34778 37.5046C3.04438 36.7655 2.89698 35.9716 2.91483 35.1729C2.93268 34.3741 3.11541 33.5877 3.45153 32.8628C3.73094 32.1638 3.8709 31.4168 3.86353 30.6641C3.49885 30.0486 3.02523 29.5047 2.46581 29.0588C1.79557 28.5905 1.23018 27.9878 0.805646 27.289C0.381115 26.5902 0.106743 25.8106 0 25C0.106743 24.1894 0.381115 23.4098 0.805646 22.711C1.23018 22.0122 1.79557 21.4095 2.46581 20.9412C3.02478 20.4954 3.49834 19.9521 3.86353 19.3375C3.87105 18.5842 3.73109 17.8367 3.45153 17.1372C3.11541 16.4124 2.93268 15.6259 2.91483 14.8272C2.89698 14.0284 3.04438 13.2346 3.34778 12.4955C3.84196 11.8572 4.46278 11.3281 5.17124 10.9413C5.87971 10.5545 6.66051 10.3184 7.46459 10.2478C8.19345 10.1418 8.89556 9.89841 9.53369 9.53062C9.90034 8.89335 10.1427 8.19226 10.2478 7.46459C10.3184 6.66069 10.5544 5.88004 10.9409 5.17161C11.3274 4.46319 11.8561 3.84227 12.4939 3.34778C13.2337 3.0446 14.028 2.89746 14.8273 2.91559C15.6265 2.93372 16.4134 3.11672 17.1387 3.45312C17.8365 3.73124 18.5817 3.87116 19.3329 3.86512C19.9493 3.5 20.4943 3.02586 20.9412 2.46581C21.4098 1.79593 22.0127 1.2308 22.7114 0.806312C23.4101 0.381822 24.1895 0.107241 25 0C25.8105 0.107241 26.5899 0.381822 27.2886 0.806312C27.9873 1.2308 28.5902 1.79593 29.0588 2.46581C29.5055 3.02492 30.0492 3.49892 30.664 3.86506C31.416 3.8691 32.1619 3.72925 32.8613 3.45306C33.586 3.11669 34.3724 2.93371 35.1712 2.91559C35.97 2.89748 36.7639 3.04462 37.5031 3.34778C38.1413 3.8412 38.6704 4.46146 39.0569 5.16948C39.4435 5.8775 39.6792 6.65793 39.7492 7.46156C39.8564 8.19106 40.1007 8.89364 40.4694 9.53216C41.1076 9.89994 41.8097 10.1433 42.5385 10.2493C43.3421 10.3197 44.1224 10.5555 44.8303 10.9421C45.5383 11.3286 46.1586 11.8575 46.6523 12.4954C46.9557 13.2345 47.1031 14.0284 47.0852 14.8271C47.0674 15.6259 46.8847 16.4123 46.5485 17.1372C46.2691 17.8362 46.1292 18.5832 46.1365 19.3359C46.5012 19.9514 46.9748 20.4953 47.5343 20.9412C48.2045 21.4095 48.7699 22.0122 49.1944 22.711C49.6189 23.4098 49.8933 24.1894 50 25C49.8933 25.8106 49.6189 26.5902 49.1944 27.289C48.7698 27.9878 48.2044 28.5905 47.5342 29.0588C46.9752 29.5046 46.5017 30.0479 46.1365 30.6625C46.129 31.4158 46.2689 32.1633 46.5485 32.8628C46.8846 33.5877 47.0673 34.3741 47.0852 35.1729C47.103 35.9716 46.9556 36.7655 46.6522 37.5046C46.158 38.1428 45.5372 38.6719 44.8288 39.0587C44.1203 39.4455 43.3395 39.6816 42.5354 39.7522C41.8066 39.8582 41.1044 40.1016 40.4663 40.4694C40.0997 41.1067 39.8573 41.8077 39.7522 42.5354C39.6816 43.3393 39.4456 44.12 39.0591 44.8284C38.6726 45.5368 38.1439 46.1577 37.5061 46.6522C36.7664 46.9554 35.972 47.1025 35.1727 47.0844C34.3735 47.0663 33.5866 46.8833 32.8613 46.5469C32.1635 46.2688 31.4183 46.1289 30.6671 46.1349C30.0507 46.5 29.5057 46.9742 29.0588 47.5342C28.5902 48.2041 27.9873 48.7692 27.2886 49.1937C26.5899 49.6182 25.8105 49.8928 25 50ZM19.104 42.9871C19.4551 42.9845 19.8049 43.0281 20.1446 43.1168C21.3608 43.5766 22.4249 44.366 23.2178 45.3964C23.7366 45.9488 24.6063 46.875 25 46.875C25.3937 46.875 26.2634 45.9488 26.7822 45.3964C27.5756 44.3652 28.6409 43.5757 29.8584 43.1168C31.174 42.9068 32.5218 43.0576 33.7584 43.5532C34.4176 43.7485 35.6322 44.1223 35.9404 43.9484C36.2517 43.7668 36.5386 42.5491 36.7095 41.8228C36.8836 40.5139 37.4194 39.2794 38.2567 38.2584C39.278 37.4212 40.5123 36.8849 41.8212 36.7096C42.5475 36.5387 43.7651 36.2533 43.9482 35.939C43.9669 35.1935 43.8329 34.4519 43.5545 33.7601C43.0545 32.523 42.9025 31.1726 43.1151 29.8553C43.5761 28.6394 44.3652 27.5751 45.3948 26.7807C45.9503 26.2619 46.875 25.3937 46.875 25C46.875 24.6063 45.9503 23.7381 45.3949 23.2193C44.365 22.4247 43.5758 21.3597 43.1152 20.1431C42.9028 18.8264 43.0547 17.4766 43.5547 16.24C43.8331 15.5481 43.9671 14.8066 43.9484 14.061C43.7653 13.7467 42.5507 13.4629 41.8244 13.292C40.5152 13.1167 39.2808 12.5799 38.2599 11.7417C37.4214 10.7205 36.8845 9.48548 36.7096 8.17572C36.5387 7.44941 36.2519 6.23328 35.9375 6.05169C35.192 6.03513 34.4508 6.16956 33.7586 6.44691C32.5218 6.94598 31.1719 7.09691 29.8554 6.88331C28.6393 6.42349 27.5752 5.63411 26.7823 4.60363C26.2634 4.05122 25.3937 3.125 25 3.125C24.6063 3.125 23.7366 4.05122 23.2178 4.60356C22.4244 5.63484 21.3591 6.42433 20.1416 6.88325C18.8261 7.09666 17.4773 6.94574 16.2416 6.44684C15.5487 6.16784 14.8061 6.03335 14.0594 6.05162C13.7481 6.23322 13.4613 7.45087 13.2903 8.17719C13.1163 9.48614 12.5804 10.7206 11.7431 11.7416C10.7218 12.5788 9.48755 13.1151 8.17866 13.2904C7.45234 13.4613 6.23469 13.7467 6.05156 14.061C6.0329 14.8065 6.1669 15.548 6.44531 16.2399C6.9454 17.477 7.09738 18.8274 6.88478 20.1447C6.42379 21.3606 5.63467 22.4249 4.60512 23.2193C4.04969 23.7381 3.125 24.6063 3.125 25C3.125 25.3937 4.04969 26.2619 4.60509 26.7807C5.63504 27.5753 6.42421 28.6403 6.88475 29.8569C7.09725 31.1736 6.94527 32.5235 6.44528 33.76C6.16687 34.4519 6.03287 35.1934 6.05153 35.939C6.23466 36.2533 7.44925 36.5371 8.17556 36.708C9.48476 36.8833 10.7192 37.4201 11.74 38.2583C12.5786 39.2795 13.1155 40.5145 13.2903 41.8243C13.4612 42.5506 13.7481 43.7667 14.0624 43.9483C14.3584 44.1253 15.5852 43.7499 16.2414 43.5531C17.1636 43.2285 18.1276 43.0378 19.104 42.9871Z"
              fill={
                hoverColor === "true"
                  ? cardIndex === 0
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
            />
            <path
              d="M20.3125 34.375C20.1073 34.3752 19.904 34.3349 19.7144 34.2563C19.5249 34.1778 19.3527 34.0625 19.2078 33.9172L12.5 26.5625L14.7094 24.3531L20.3125 30.6031L35.3013 15.6143L37.5107 17.8236L21.4172 33.9172C21.2723 34.0625 21.1001 34.1778 20.9106 34.2563C20.721 34.3349 20.5177 34.3752 20.3125 34.375Z"
              fill={
                hoverColor === "true"
                  ? cardIndex === 0
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
            />
          </g>
          <defs>
            <clipPath id="clip0_3661_5067">
              <rect width="50" height="50" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : name === "solutionficon2" ? (
        <svg
          width="50"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.132 43.6394H21.9366V45.3196H17.7578C17.2839 45.3196 16.8962 45.7073 16.8962 46.1812V49.5328C16.8962 50.0068 17.2839 50.3945 17.7578 50.3945H42.245C42.7275 50.3945 43.1066 50.0068 43.1066 49.5328V46.1812C43.1066 45.7073 42.7275 45.3196 42.245 45.3196H38.0662V43.6394H48.8708C50.3442 43.6394 51.5419 42.4418 51.5419 40.9684V12.2851C51.5419 10.8117 50.3442 9.60547 48.8708 9.60547H11.132C9.65857 9.60547 8.46094 10.8117 8.46094 12.2851V40.9684C8.46094 42.4418 9.65857 43.6394 11.132 43.6394ZM10.1842 12.2851C10.1842 11.7595 10.615 11.3287 11.132 11.3287H48.8708C49.3964 11.3287 49.8186 11.7595 49.8186 12.2851V35.8159H10.1842V12.2851Z"
            fill={
              hoverColor === "true"
                ? cardIndex === 1
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
          />
          <path
            d="M30.0013 25.7546C31.2058 25.7546 32.1823 24.7781 32.1823 23.5736C32.1823 22.369 31.2058 21.3926 30.0013 21.3926C28.7968 21.3926 27.8203 22.369 27.8203 23.5736C27.8203 24.7781 28.7968 25.7546 30.0013 25.7546Z"
            fill={
              hoverColor === "true"
                ? cardIndex === 1
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
          />
          <path
            d="M30.0015 15.6025C22.8673 15.6025 17.2495 22.7454 17.0169 23.0469C16.7756 23.3571 16.7756 23.788 17.0169 24.0981C17.2495 24.4083 22.8673 31.5425 30.0015 31.5425C37.1357 31.5425 42.7535 24.4083 42.9861 24.0981C43.2273 23.788 43.2273 23.3571 42.9861 23.0469C42.7535 22.7454 37.1357 15.6025 30.0015 15.6025ZM30.0027 27.4786C27.8495 27.4786 26.0984 25.7272 26.0984 23.5744C26.0984 21.4216 27.8495 19.6702 30.0027 19.6702C32.1559 19.6702 33.9069 21.4216 33.9069 23.5744C33.9069 25.7272 32.1559 27.4786 30.0027 27.4786Z"
            fill={
              hoverColor === "true"
                ? cardIndex === 1
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
          />
        </svg>
      ) : name === "solutionficon3" ? (
        <svg
          width="40"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.9984 27.7996C19.3984 27.7996 14.8984 23.2996 14.8984 17.6996C14.8984 12.0996 19.3984 7.59961 24.9984 7.59961C30.5984 7.59961 35.0984 12.0996 35.0984 17.6996C35.0984 23.2996 30.5984 27.7996 24.9984 27.7996ZM24.9984 11.5996C21.5984 11.5996 18.8984 14.2996 18.8984 17.6996C18.8984 21.0996 21.5984 23.7996 24.9984 23.7996C28.3984 23.7996 31.0984 21.0996 31.0984 17.6996C31.0984 14.2996 28.3984 11.5996 24.9984 11.5996Z"
            fill={
              hoverColor === "true"
                ? cardIndex === 2
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
          />
          <path
            d="M24.9969 49C24.2969 49 23.6969 48.7 23.3969 48.1C21.7969 45.9 8.29688 26.3 8.29688 17.7C8.29688 8.5 15.7969 1 24.9969 1C34.1969 1 41.6969 8.5 41.6969 17.7C41.6969 26.2 28.0969 45.9 26.5969 48.1C26.2969 48.7 25.6969 49 24.9969 49ZM24.9969 5C17.9969 5 12.2969 10.7 12.2969 17.7C12.2969 23.1 20.3969 36.4 24.9969 43.4C29.5969 36.4 37.6969 23.1 37.6969 17.7C37.6969 10.7 31.9969 5 24.9969 5Z"
            fill={
              hoverColor === "true"
                ? cardIndex === 2
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
          />
        </svg>
      ) : name === "solutionficon4" ? (
        <svg
          width="40"
          height="51"
          viewBox="0 0 50 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3661_5110)">
            <path
              d="M6.94893 9.04528H29.221M6.94893 12.1205H29.221M6.94893 15.1957H29.221M6.94893 18.2725H29.221M6.94893 21.3477H29.221M6.94893 24.4229H29.221M6.94893 27.4998H29.221M6.94893 30.575H29.221M6.94893 33.6502H29.221M6.94893 36.7254H29.221M34.6818 43.8145C34.4623 44.131 34.1693 44.3895 33.8279 44.5679C33.4866 44.7464 33.107 44.8394 32.7219 44.839H3.44974C3.13632 44.8392 2.82593 44.7777 2.53631 44.6579C2.24668 44.5381 1.9835 44.3624 1.76181 44.1408C1.54011 43.9193 1.36424 43.6562 1.24425 43.3667C1.12426 43.0772 1.0625 42.7668 1.0625 42.4534V3.31723C1.06294 2.68438 1.31464 2.0776 1.76229 1.63026C2.20994 1.18293 2.81689 0.93164 3.44974 0.931641H32.7219C33.3544 0.932078 33.9609 1.18356 34.4082 1.63085C34.8555 2.07814 35.107 2.68467 35.1074 3.31723V13.9501"
              stroke={
                hoverColor === "true"
                  ? cardIndex === 3
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
              strokeWidth="1.6"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <path
              d="M35.0945 35.6448C40.665 30.0743 40.665 21.0429 35.0945 15.4724C29.5241 9.90195 20.4926 9.90195 14.9221 15.4724C9.35168 21.0429 9.35168 30.0743 14.9221 35.6448C20.4926 41.2152 29.5241 41.2152 35.0945 35.6448Z"
              fill="white"
            />
            <path
              opacity="0.05"
              d="M33.2543 33.9715C37.81 29.4158 37.81 22.0295 33.2543 17.4738C28.6986 12.9181 21.3124 12.9181 16.7567 17.4738C12.2009 22.0295 12.2009 29.4158 16.7567 33.9715C21.3124 38.5272 28.6986 38.5272 33.2543 33.9715Z"
              fill={
                hoverColor === "true"
                  ? cardIndex === 3
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
            />
            <path
              d="M33.2543 33.8074C37.81 29.2517 37.81 21.8655 33.2543 17.3098C28.6986 12.754 21.3124 12.754 16.7567 17.3098C12.2009 21.8655 12.2009 29.2517 16.7567 33.8074C21.3124 38.3631 28.6986 38.3631 33.2543 33.8074Z"
              stroke={
                hoverColor === "true"
                  ? cardIndex === 3
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
              strokeWidth="1.6"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <path
              d="M34.6817 32.0781L37.0969 34.1832M31.4844 35.4024L33.8997 37.5076"
              stroke={
                hoverColor === "true"
                  ? cardIndex === 3
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
              strokeWidth="1.6"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <path
              opacity="0.75"
              d="M44.5131 49.3429L34.4246 39.304C34.2828 39.1626 34.2008 38.972 34.1956 38.7718C34.1904 38.5715 34.2623 38.377 34.3966 38.2283L37.7094 34.579C37.7806 34.5009 37.8669 34.438 37.9631 34.3942C38.0593 34.3505 38.1634 34.3267 38.2691 34.3244C38.3748 34.3221 38.4798 34.3413 38.5779 34.3808C38.6759 34.4203 38.7649 34.4793 38.8395 34.5543L48.8669 44.674C48.8669 44.674 50.5645 46.309 48.5847 48.396C47.293 49.7554 46.214 51.0356 44.5131 49.3429Z"
              stroke={
                hoverColor === "true"
                  ? cardIndex === 3
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
              strokeWidth="1.6"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <mask
              id="mask0_3661_5110"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="15"
              y="16"
              width="20"
              height="19"
            >
              <path
                d="M25.9094 34.7392C30.9789 34.2377 34.682 29.7215 34.1804 24.652C33.6789 19.5825 29.1627 15.8794 24.0932 16.381C19.0237 16.8825 15.3206 21.3987 15.8222 26.4682C16.3237 31.5377 20.8399 35.2407 25.9094 34.7392Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_3661_5110)">
              <path
                opacity="0.75"
                d="M6.94531 8.88086H29.2174M6.94531 11.9561H29.2174M6.94531 15.0313H29.2174M6.94531 18.1081H29.2174M6.94531 21.1833H29.2174M6.94531 24.2585H29.2174M6.94531 27.3337H29.2174M6.94531 30.4105H29.2174M6.94531 33.4857H29.2174M6.94531 36.5609H29.2174"
                stroke={
                  hoverColor === "true"
                    ? cardIndex === 3
                      ? "#FFFFFF"
                      : "#168DEF"
                    : "#168DEF"
                }
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_3661_5110">
              <rect width="50" height="50.6599" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : name === "solutionficon5" ? (
        <svg
          width="40"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3661_4345)">
            <path
              d="M16.6667 50H18.75C19.3025 50 19.8324 49.7805 20.2231 49.3898C20.6138 48.9991 20.8333 48.4692 20.8333 47.9167C20.8333 47.3641 20.6138 46.8342 20.2231 46.4435C19.8324 46.0528 19.3025 45.8333 18.75 45.8333H16.6667C15.0091 45.8333 13.4194 45.1749 12.2472 44.0028C11.0751 42.8306 10.4167 41.2409 10.4167 39.5833V10.4167C10.4167 8.75906 11.0751 7.16935 12.2472 5.99725C13.4194 4.82515 15.0091 4.16667 16.6667 4.16667H33.3333C34.9909 4.16667 36.5806 4.82515 37.7528 5.99725C38.9249 7.16935 39.5833 8.75906 39.5833 10.4167V18.75C39.5833 19.3025 39.8028 19.8324 40.1935 20.2231C40.5842 20.6138 41.1141 20.8333 41.6667 20.8333C42.2192 20.8333 42.7491 20.6138 43.1398 20.2231C43.5305 19.8324 43.75 19.3025 43.75 18.75V10.4167C43.7467 7.65501 42.6482 5.00741 40.6954 3.05462C38.7426 1.10184 36.095 0.00330804 33.3333 0L16.6667 0C13.905 0.00330804 11.2574 1.10184 9.30462 3.05462C7.35184 5.00741 6.25331 7.65501 6.25 10.4167V39.5833C6.25331 42.345 7.35184 44.9926 9.30462 46.9454C11.2574 48.8982 13.905 49.9967 16.6667 50Z"
              fill={
                hoverColor === "true"
                  ? cardIndex === 4
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
            />
            <path
              d="M33.3359 10.416H16.6693C16.1167 10.416 15.5868 10.6355 15.1961 11.0262C14.8054 11.4169 14.5859 11.9468 14.5859 12.4993C14.5859 13.0519 14.8054 13.5818 15.1961 13.9725C15.5868 14.3632 16.1167 14.5827 16.6693 14.5827H33.3359C33.8885 14.5827 34.4184 14.3632 34.8091 13.9725C35.1998 13.5818 35.4193 13.0519 35.4193 12.4993C35.4193 11.9468 35.1998 11.4169 34.8091 11.0262C34.4184 10.6355 33.8885 10.416 33.3359 10.416ZM35.4193 20.8327C35.4193 20.2801 35.1998 19.7502 34.8091 19.3595C34.4184 18.9688 33.8885 18.7493 33.3359 18.7493H16.6693C16.1167 18.7493 15.5868 18.9688 15.1961 19.3595C14.8054 19.7502 14.5859 20.2801 14.5859 20.8327C14.5859 21.3852 14.8054 21.9151 15.1961 22.3058C15.5868 22.6965 16.1167 22.916 16.6693 22.916H33.3359C33.8885 22.916 34.4184 22.6965 34.8091 22.3058C35.1998 21.9151 35.4193 21.3852 35.4193 20.8327ZM16.6693 27.0827C16.1167 27.0827 15.5868 27.3022 15.1961 27.6929C14.8054 28.0836 14.5859 28.6135 14.5859 29.166C14.5859 29.7185 14.8054 30.2485 15.1961 30.6392C15.5868 31.0299 16.1167 31.2493 16.6693 31.2493H25.0026C25.5551 31.2493 26.085 31.0299 26.4757 30.6392C26.8664 30.2485 27.0859 29.7185 27.0859 29.166C27.0859 28.6135 26.8664 28.0836 26.4757 27.6929C26.085 27.3022 25.5551 27.0827 25.0026 27.0827H16.6693ZM39.3339 26.8306L27.5484 38.616C27.2799 38.8842 27.0897 39.2206 26.9984 39.5889L25.063 47.416C24.977 47.7644 24.9825 48.1291 25.0788 48.4747C25.1752 48.8204 25.3592 49.1353 25.613 49.3889C25.8681 49.6406 26.1831 49.8231 26.5283 49.9193C26.8735 50.0155 27.2374 50.0223 27.5859 49.9389L35.4193 48.0035C35.7879 47.913 36.1245 47.7227 36.3922 47.4535L48.1755 35.6702C48.7637 35.0916 49.2315 34.4023 49.552 33.6421C49.8725 32.8818 50.0393 32.0656 50.0427 31.2406C50.0462 30.4156 49.8862 29.598 49.5722 28.8351C49.2581 28.0722 48.796 27.379 48.2127 26.7955C47.6294 26.212 46.9363 25.7499 46.1735 25.4356C45.4106 25.1213 44.5931 24.9612 43.7681 24.9645C42.943 24.9677 42.1268 25.1343 41.3664 25.4546C40.6061 25.7749 39.9167 26.2425 39.338 26.8306H39.3339ZM33.8505 44.0973L29.9359 45.066L30.9047 41.1514L37.8609 34.1952L40.8068 37.141L33.8505 44.0973ZM45.2255 32.7223L43.7526 34.1952L40.8068 31.2493L42.2797 29.7764C42.6704 29.3859 43.2002 29.1665 43.7526 29.1665C44.305 29.1665 44.8348 29.3859 45.2255 29.7764C45.6101 30.1703 45.8253 30.6989 45.8253 31.2493C45.8253 31.7998 45.6101 32.3284 45.2255 32.7223Z"
              fill={
                hoverColor === "true"
                  ? cardIndex === 4
                    ? "#FFFFFF"
                    : "#168DEF"
                  : "#168DEF"
              }
            />
          </g>
          <defs>
            <clipPath id="clip0_3661_4345">
              <rect width="50" height="50" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : name === "solutionficon6" ? (
        <svg
          width="40"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M45.0817 29.991H36.6478C33.551 29.9891 31.041 27.4809 31.0391 24.3842C31.0391 21.2874 33.551 18.7792 36.6478 18.7773H45.0817"
            stroke={
              hoverColor === "true"
                ? cardIndex === 5
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.6031 24.2559H36.9531"
            stroke={
              hoverColor === "true"
                ? cardIndex === 5
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1436 6.25H34.1507C40.1885 6.25 45.0833 11.1448 45.0833 17.1826V32.1348C45.0833 38.1726 40.1885 43.0674 34.1507 43.0674H16.1436C10.1057 43.0674 5.21094 38.1726 5.21094 32.1348V17.1826C5.21094 11.1448 10.1057 6.25 16.1436 6.25Z"
            stroke={
              hoverColor === "true"
                ? cardIndex === 5
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6641 15.7051H25.912"
            stroke={
              hoverColor === "true"
                ? cardIndex === 5
                  ? "#FFFFFF"
                  : "#168DEF"
                : "#168DEF"
            }
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ): name === "right-arrow-icon" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="14"
          viewBox="0 0 25 14"
          fill={fill ? fill : "none"}
        >
          <path
            d="M2 7H23.3547"
            stroke={fill ? fill : "#202020"}
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.2539 12.3333L23.3552 7"
            stroke={fill ? fill : "#202020"}
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.2539 1.66602L23.3552 6.99935"
            stroke={fill ? fill : "#202020"}
            strokeWidth="2.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ): name === "prev-btn" ? (
        <svg
          width="64"
          height="50"
          viewBox="0 0 64 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="63"
            height="49"
            rx="9.5"
            fill="#F8F8F8"
            stroke="#EAEAEA"
          />
          <path
            d="M36.6558 32.6478C36.8762 32.4222 37 32.1163 37 31.7974C37 31.4784 36.8762 31.1725 36.6558 30.947L30.8373 24.9927L36.6558 19.0385C36.87 18.8117 36.9884 18.5078 36.9858 18.1924C36.9831 17.877 36.8595 17.5753 36.6415 17.3523C36.4236 17.1293 36.1288 17.0028 35.8206 17C35.5124 16.9973 35.2154 17.1185 34.9937 17.3377L28.3442 24.1423C28.1238 24.3679 28 24.6738 28 24.9927C28 25.3117 28.1238 25.6176 28.3442 25.8432L34.9937 32.6478C35.2142 32.8733 35.5131 33 35.8248 33C36.1365 33 36.4354 32.8733 36.6558 32.6478Z"
            fill="black"
          />
        </svg>
      ) : name === "next-btn" ? (
        <svg
          width="64"
          height="50"
          viewBox="0 0 64 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="63"
            height="49"
            rx="9.5"
            fill="#F8F8F8"
            stroke="#EAEAEA"
          />
          <path
            d="M28.3442 17.3522C28.1238 17.5778 28 17.8837 28 18.2026C28 18.5216 28.1238 18.8275 28.3442 19.053L34.1627 25.0073L28.3442 30.9615C28.13 31.1883 28.0116 31.4922 28.0142 31.8076C28.0169 32.123 28.1405 32.4247 28.3585 32.6477C28.5764 32.8707 28.8712 32.9972 29.1794 33C29.4876 33.0027 29.7846 32.8815 30.0063 32.6623L36.6558 25.8577C36.8762 25.6321 37 25.3262 37 25.0073C37 24.6883 36.8762 24.3824 36.6558 24.1568L30.0063 17.3522C29.7858 17.1267 29.4869 17 29.1752 17C28.8635 17 28.5646 17.1267 28.3442 17.3522Z"
            fill="black"
          />
        </svg>
      ): name === "massage" ? (
        <svg
          width="27"
          height="22"
          viewBox="0 0 27 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.9445 3.87821V17.3099C25.9445 18.0732 25.6412 18.8053 25.1015 19.3451C24.5617 19.8848 23.8296 20.1881 23.0663 20.1881H3.87821C3.11486 20.1881 2.38278 19.8848 1.84301 19.3451C1.30324 18.8053 1 18.0732 1 17.3099V3.87821M25.9445 3.87821C25.9445 3.11486 25.6412 2.38278 25.1015 1.84301C24.5617 1.30324 23.8296 1 23.0663 1H3.87821C3.11486 1 2.38278 1.30324 1.84301 1.84301C1.30324 2.38278 1 3.11486 1 3.87821M25.9445 3.87821V4.18906C25.9445 4.68046 25.8188 5.16369 25.5792 5.59272C25.3396 6.02175 24.9941 6.3823 24.5757 6.64001L14.9817 12.5435C14.5278 12.8231 14.0053 12.9711 13.4722 12.9711C12.9392 12.9711 12.4166 12.8231 11.9628 12.5435L2.36875 6.64129C1.95035 6.38358 1.6049 6.02303 1.3653 5.594C1.12571 5.16497 0.999946 4.68174 1 4.19034V3.87821"
            stroke="white"
            strokeWidth="1.64469"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : name === "location" ? (
        <svg
          width="21"
          height="26"
          viewBox="0 0 21 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.1881 10.594C20.1881 19.7301 10.594 24.9851 10.594 24.9851C10.594 24.9851 1 19.7301 1 10.594C1 8.04954 2.0108 5.60926 3.81003 3.81003C5.60926 2.0108 8.04954 1 10.594 1C13.1385 1 15.5788 2.0108 17.378 3.81003C19.1773 5.60926 20.1881 8.04954 20.1881 10.594V10.594Z"
            stroke="white"
            strokeWidth="1.64469"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.433 10.5935C14.433 11.6113 14.0287 12.5874 13.309 13.3071C12.5893 14.0268 11.6132 14.4311 10.5954 14.4311C9.57763 14.4311 8.60151 14.0268 7.88182 13.3071C7.16213 12.5874 6.75781 11.6113 6.75781 10.5935C6.75781 9.57567 7.16213 8.59956 7.88182 7.87987C8.60151 7.16018 9.57763 6.75586 10.5954 6.75586C11.6132 6.75586 12.5893 7.16018 13.309 7.87987C14.0287 8.59956 14.433 9.57567 14.433 10.5935V10.5935Z"
            stroke="white"
            strokeWidth="1.64469"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ): name === "arrow" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 25 15"
                  fill={fill ? fill : "#000"}
                >
                  <path
                    d="M2 7.6239H23.3547"
                    stroke={fill ? fill : "#202020"}
                    strokeWidth="2.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.2539 12.9572L23.3552 7.6239"
                    stroke={fill ? fill : "#202020"}
                    strokeWidth="2.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.2539 2.29056L23.3552 7.62389"
                    stroke={fill ? fill : "#202020"}
                    strokeWidth="2.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                " "
            )}
        </>
    );
}